// components/AuthInitializer.jsx
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useRefreshMutation } from "../../app/store/api/authApi";
import { clearCredentials, setCredentials } from "../../app/store/authSlice";

export default function AuthInitializer({ children }) {
  const dispatch = useDispatch();
  const [refresh] = useRefreshMutation();

  useEffect(() => {
    refresh()
      .unwrap()
      .then((result) => {
        dispatch(setCredentials({ accessToken: result.accessToken, idToken: result.idToken }));
      })
      .catch(() => {
        dispatch(clearCredentials());
      });
  }, []);

  return children;
}
